import { createSlice } from '@reduxjs/toolkit'
import { decodeToken } from '../utils/decodeToken'

export const user = createSlice({
  name: 'user',
  initialState: {
    value: localStorage.getItem("loginToken") == null ? "" : decodeToken(localStorage.getItem("loginToken")).message ,
  },
  reducers: {
    logOut: (state) => {
      state.value =""
    },
    logIn: (state, action) => {
      state.value = action.payload
    },
  },
})

export const { logOut, logIn} = user.actions
export default user.reducer